export default __webpack_public_path__ + "images/dfcc465d0aec78168dd0bcc9ea888968.svg";